import { Helmet } from "react-helmet-async";
import { Card, Container } from "react-bootstrap";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>หน้าแรก</title>
        <meta name="description" content="Home Page" />
      </Helmet>

      <Container fluid className="p-5">
        <Card className="p-5 border-0 bg-transparent">
          <Card.Body className="p-5 text-center">
            <Card.Img
              width="243px"
              height="288px"
              src={`${process.env.REACT_APP_STORAGE_URL}/company-logo/Logo_ODO-removebg-preview 1.svg`}
              alt="Logo Icon"
            />
            <Card.Title className="mt-3 fw-bold">
              Web Application Service & Maintenances Interface SAP Business One
            </Card.Title>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
